<template>
	<div class="cbs-dynamic-form">
		<div id="cbs-dynamic-form-loading" v-if="!isLoadedInitData"></div>

		<div v-else-if="isLoadedInitData" class="cbs-dynamic-form__control my-5" v-for="(field, index) in localValue" :key="field.id">
			<!-- RADIO -->
			<radio-control v-if="field.control === $constant.request.control.radio" v-model="localValue[index]" />

			<!-- CHECKBOX -->
			<checkbox-control v-if="field.control === $constant.request.control.checkbox" v-model="localValue[index]" />

			<!-- DROPDOWN -->
			<dropdown-control v-if="field.control === $constant.request.control.dropdown" v-model="localValue[index]" />

			<!-- TEXT -->
			<text-control v-if="field.control === $constant.request.control.text" v-model="localValue[index]" />

			<!-- TEXTAREA -->
			<textarea-control v-if="field.control === $constant.request.control.textarea" v-model="localValue[index]" />

			<!-- NUMBER -->
			<number-control v-if="field.control === $constant.request.control.number" v-model="localValue[index]" />

			<!-- CALCULATOR -->
			<calculator-control v-if="field.control === $constant.request.control.calculator" v-model="localValue[index]" />

			<!-- ATTACH FILE -->
			<attachment-control v-if="field.control === $constant.request.control.attach" v-model="localValue[index]" :mappedAttachObj="mappedAttachObj" @onChange="handleSetMappedAtachObj" />

			<!-- DATETIME -->
			<datetime-control v-if="field.control === $constant.request.control.datetime" v-model="localValue[index]" />

			<!-- RELATION -->
			<relation-control v-if="field.control === $constant.request.control.relation" v-model="localValue[index]" @onReInitAutofillData="handleReInitAutofillData" :indexValue="index" />

			<!-- REPEATER -->
			<template v-if="field.control === $constant.request.control.repeater">
				<repeater-control
					v-model="localValue[index].value"
					:fieldData="localValue[index]"
					:data-vv-as="field.title"
					:mappedAttachObj="mappedAttachObj"
					:name="`${field.title}-${field.id}`"
					v-validate="!field.is_optional ? 'required' : ''"
					@onChangeMappedAttachObj="newMappedAttachObj => $emit('onChangeMappedAttachObj', newMappedAttachObj)"
				/>
				<span class="text-danger text-sm" v-if="!localValue[index].is_optional">{{ errors.first(`${localValue[index].title}-${localValue[index].id}`) }}</span>
			</template>

			<!-- LABEL -->
			<label-content
                v-if="localValue[index].control === $constant.request.control.label"
                :value="localValue[index]"
            />

			<!-- AUTOFILL -->
			<autofill-control :key="reloadKey" v-if="field.control === $constant.request.control.autofill" v-model="localValue[index]" :config="field" :rawData="localValue"  />
		</div>
	</div>
</template>

<script>
import { has as lodashHas, isEmpty as lodashIsEmpty, forEach as lodashForEach } from "lodash";
import Calculator from "@/utils/calculator.js";
import requestV2GQL from "@/http/requests/request/request_v2_gql.js";

import TextControl from "./TextControl.vue";
import RadioControl from "./RadioControl.vue";
import LabelContent from "./LabelContent.vue";
import NumberControl from "./NumberControl.vue";
import TextareaControl from "./TextareaControl.vue";
import CheckboxControl from "./CheckboxControl.vue";
import DropdownControl from "./DropdownControl.vue";
import DatetimeControl from "./DatetimeControl.vue";
import RelationControl from "./RelationControl.vue";
import RepeaterControl from "./RepeaterControl.vue";
import CalculatorControl from "./CalculatorControl.vue";
import AttachmentControl from "./AttachmentControl.vue";
import AutofillControl from "./AutofillControl.vue";

export default {
	inject: ["parentValidator"],
	name: "CbsDynamicForm",
	components: {
		TextControl,
        RadioControl,
        LabelContent,
		NumberControl,
		RelationControl,
		TextareaControl,
		CheckboxControl,
		DropdownControl,
		DatetimeControl,
		RepeaterControl,
		CalculatorControl,
		AttachmentControl,
		AutofillControl
	},
	props: {
		value: {
			type: Array,
			required: true,
			validator: prop => {
				if (!lodashIsEmpty(prop)) {
					return prop.every(
						objData =>
							lodashHas(objData, "id") &&
							lodashHas(objData, "title") &&
							lodashHas(objData, "control") &&
							lodashHas(objData, "children") &&
							lodashHas(objData, "attributes") &&
							lodashHas(objData, "is_optional") &&
							lodashHas(objData, "description")
					);
				}
				return true;
			}
		},
		mappedAttachObj: {
			type: Object,
			default() {
				return {};
			}
		}
	},
	emits: {
		onSetInitData: {},
		onChangeMappedAttachObj: {},
		onReInitAutofillData: {},
	},
	data() {
		return {
			isLoadedInitData: false,
			relationSelectedValues: {},
			reloadKey: Date.now(),
		};
	},
	computed: {
		localValue: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			}
		},
		mappedRelationSelectedValues() {
			const result = {};
			lodashForEach(this.relationSelectedValues, (selectedValue, key) => selectedValue.map(item => (result[key] = (result[key] || []).concat(item.value))));
			return result;
		}
	},
	watch: {
		localValue: {
			handler: function(newValue) {
				this.handleCalculateFields(newValue);
				// this.reloadKey = Date.now();
			},
			deep: true
		}
	},
	methods: {
		handleReInitAutofillData(data) {
			if (data && data.hasOwnProperty('indexValue')) {
				let value = this.localValue[data.indexValue];
				if (value) {
					let isReload = false;
					let localValue = this.localValue;
					localValue.forEach((item, index) => {
						if (item.control == this.$constant.request.control.autofill) {
							item.value = null;
							localValue[index] = item;
							isReload = true;
						}
					});
					if (isReload) {
						this.localValue = localValue;
						this.reloadKey = Date.now();
					}
				}
			}
		},
		handleCalculateFields(form) {
			let calNumbers = {};
			form.forEach(field => {
				if (field.control === this.$constant.request.control.number || field.control === this.$constant.request.control.calculator) {
					calNumbers[field.id] = field.value;
				}
				if (field.control === this.$constant.request.control.repeater) {
					// calNumbers[field.id] = field.value;
					// console.log('field: ', field);
					// console.log('field: ', JSON.parse(field.children));
					let children = JSON.parse(field.children);
					let numberIndexKeys = {};
					if (Array.isArray(children)) {
						children.forEach((child, index) => {
							if (child.control == this.$constant.request.control.number || child.control == this.$constant.request.control.calculator) {
								numberIndexKeys[child.id] = 1;
							}
						});
						// console.log('numberIndexKeys: ', numberIndexKeys);
					}
					if (Array.isArray(field.value)) {
						field.value.forEach(child => {
							for (let k in numberIndexKeys) {
								if (child.hasOwnProperty(k)) {
									if (!calNumbers.hasOwnProperty(k)) {
										calNumbers[k] = 0;
									}
									// console.log('child[k]: ', k, child[k]);
									calNumbers[k] += child[k];
								}
							}
						})
					}
				}
				// console.log('calNumbers: ', calNumbers);

				if (field.control === this.$constant.request.control.calculator) {
                    const attributesValue = typeof field.attributes === "string" ? JSON.parse(field.attributes) : field.attributes;
					// console.log('attributesValue: ', attributesValue);
					let rexStr = attributesValue.cal_exp || "";
					for (let calNumKey in calNumbers) {
						if (calNumbers.hasOwnProperty(calNumKey)) {
							let repStr = "_" + calNumKey;
							let re = new RegExp(repStr, "g");
							rexStr = rexStr.replace(re, calNumbers[calNumKey]);
						}
					}
					let calculator = new Calculator();
					let result = calculator.calculate(rexStr);
					if (isNaN(result)) {
						result = 0;
					}
					field.value = Number(result);
				}

				return field;
			});
		},
		handleSetMappedAtachObj(files) {
			const newMappedAttachObj = { ...this.mappedAttachObj };
			files.forEach(file => (newMappedAttachObj[file.id] = file));
			this.$emit("onChangeMappedAttachObj", newMappedAttachObj);
		},
		async setRelationsLocalValue(mappedRelationsValueObj = {}) {
			await new Promise(resolve => {
				this.localValue = this.localValue.map(field => {
					if (field.control === this.$constant.request.control.relation && !lodashIsEmpty(field.value)) {
                        const parsedAttributes = JSON.parse(field.attributes);
						const selectedRelationsData = mappedRelationsValueObj[parsedAttributes.related_model] ? mappedRelationsValueObj[parsedAttributes.related_model].data || [] : [];

						return {
							...field,
							value: selectedRelationsData.filter(selectedData => field.value.includes(selectedData.id))
						};
					}
					return field;
				});
				resolve(true);
			});
		},
		async setInitRelations() {
			if (!lodashIsEmpty(this.localValue)) {
				try {
					this.$vs.loading({
						container: "#cbs-dynamic-form-loading",
						scale: 0.6
					});
					this.localValue.forEach(field => {
						if (field.control === this.$constant.request.control.relation && !lodashIsEmpty(field.value)) {
                            const parsedAttributes = JSON.parse(field.attributes);
							this.relationSelectedValues[parsedAttributes.related_model] = [...(this.relationSelectedValues[parsedAttributes.related_model] || []), { fieldId: field.id, value: field.value }];
						}
					});
					if (!lodashIsEmpty(this.relationSelectedValues)) {
						const response = await requestV2GQL.getCombinedRelationDataByModel(this.mappedRelationSelectedValues);
						this.setRelationsLocalValue(response || {});
					}
				} catch (error) {
					this.$helper.notifyError({ error, context: this });
				} finally {
					this.$nextTick(() => this.$vs.loading.close("#cbs-dynamic-form-loading > .con-vs-loading"));
				}
			}
		}
	},
	created() {
		if (this.parentValidator) {
			this.$validator = this.parentValidator;
		}
	},
	async mounted() {
		await this.setInitRelations();
		this.isLoadedInitData = true;
		this.$emit("onSetInitData", this.localValue);
	}
};
</script>

<style></style>
